<div class="view-dealer-details-container">
  <div class="header">
    <mat-icon class="back-arrow" (click)="goBack()">chevron_left</mat-icon>
    <span class="title">Dealer Details</span>
  </div>

  <div class="form-section"> <div class="form-field">
      <label class="label-text" for="primaryMobile">Primary mobile number</label>
      <label>{{ dealer?.mobileNumberPrimary }}</label>
    </div>

    <div class="form-field">
      <label class="label-text" for="alternateMobile">Alternate mobile number</label>
      <label>{{ dealer?.mobileNumberAlternate }}</label>
    </div>

    <div class="form-field">
      <label class="label-text" for="ownerName">Owner name</label>
      <label>{{ dealer?.retailerName }}</label>
    </div>

    <div class="form-field">
      <label class="label-text">Shop type</label>
      <label>{{ dealer?.type }}</label>
    </div>

    <div class="form-field">
      <label class="label-text" for="shopName">Shop name</label>
      <label>{{ dealer?.shopName }}</label>
    </div>

    <div class="form-field">
      <label class="label-text" for="county">County</label>
      <label>{{ dealer?.state }}</label>
    </div>

    <div class="form-field">
      <label class="label-text" for="subCounty">Sub county</label>
      <label>{{ dealer?.district }}</label>
    </div>

    <div class="form-field">
      <label class="label-text" for="ward">Ward</label>
      <label>{{ dealer?.village }}</label>
    </div>

    <div class="image-preview-section" *ngIf="dealer?.retailerShopImage">
      <label class="label-text">Shop Photo</label> <img [src]="dealer?.retailerShopImage" alt="Shop Photo" class="shop-image-preview" />
    </div>
    <div class="no-image-message" *ngIf="!dealer?.retailerShopImage">
      <p>No shop photo available.</p>
    </div>

  </div>

  <div class="submit-button-wrapper"> <button mat-raised-button
      color="primary"
      type="button" class="submit-button" [disabled]="isEditDisabled"
      (click)="editDetails()"
    >
      {{ buttonText }}
    </button>
  </div>
</div>